import React from "react";
import { JSONRenderer } from "../../JSONRenderer/JSONRenderer";
import {
  MessageBlock,
  MessageHeader,
  MessageContent,
} from "./MessageDisplay.styles";
import { parseNestedJSON } from "../../../../../../../helpers/json-helpers";

export const MessageDisplay = ({ message, t }) => {
  if (!message) return null;

  // Try to parse content if it might be JSON
  let content = message.content;
  let isJSON = false;

  // Handle case where content is already an object
  if (typeof content === "object" && content !== null) {
    isJSON = true;
  } else if (
    typeof content === "string" &&
    (content.startsWith("{") || content.startsWith("["))
  ) {
    try {
      const parsed = parseNestedJSON(content);
      if (typeof parsed === "object") {
        content = parsed;
        isJSON = true;
      }
    } catch (e) {
      // Keep original content if parsing fails
    }
  }

  const roleName =
    message.role === "developer" ? t("logs.developer") : t("logs.user");

  return (
    <MessageBlock role={message.role}>
      <MessageHeader>{roleName}</MessageHeader>
      <MessageContent>
        {isJSON ? <JSONRenderer data={content} /> : content}
      </MessageContent>
    </MessageBlock>
  );
};
